import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { DELETE_SURVEY } from './constants';
import {
  DeleteSurveySuccess,
  DeleteSurveyError,
  DeleteSurveyDataActionTypes,
  DeleteSurveyState,
} from './types';

const initialState: DeleteSurveyState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: DeleteSurveyDataActionTypes,
  ): DeleteSurveyState => {
    switch (action.type) {
      case DELETE_SURVEY + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case DELETE_SURVEY + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as DeleteSurveySuccess).payload;
        break;
      }
      case DELETE_SURVEY + FAILURE: {
        draft.status = rejected;
        draft.error = (action as DeleteSurveyError).error;
        break;
      }
      case DELETE_SURVEY + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
